import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { fmtMoney, fmtPct, fmtNum } from './story-utils';

interface RevenueHeroProps {
  revenueLoss: number;
  monthlyClicks: number;
  portfolioAvgCvr: number;
  pageCvr: number;
  avgConvValue: number;
}

export function RevenueHero({ revenueLoss, monthlyClicks, portfolioAvgCvr, pageCvr, avgConvValue }: RevenueHeroProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className={`story-revenue story-anim-2${open ? ' story-acc-open' : ''}`}>
      <div className="story-rev-trigger" onClick={() => setOpen(o => !o)}>
        <div className="story-rev-label">
          Estimated Monthly<br />Revenue Loss
        </div>
        <div className="story-rev-num">
          {fmtMoney(revenueLoss)}<span className="unit">/mo</span>
        </div>
        <div className="story-rev-chev">
          <ChevronDown />
        </div>
      </div>
      <div className="story-rev-body">
        <div className="story-rev-calc">
          <code>{fmtNum(monthlyClicks)} clicks</code>
          {' × '}
          <code>{fmtPct(portfolioAvgCvr)} avg CVR − {fmtPct(pageCvr)} page CVR</code>
          {' × '}
          <code>{fmtMoney(avgConvValue)} avg value</code>
          {' — sourced from your Google Ads account.'}
        </div>
      </div>
    </div>
  );
}
